import { Edit3, Trash2 } from "lucide-react";
import type { Iso2700127701ControlModificacion } from "../../types/control-modificaciones";
import {
  Iso2700127701DataTable,
  Iso2700127701IconButton,
  Iso2700127701ScrollableCell,
  type Iso2700127701TableColumn,
} from "../shared";

type Props = {
  rows: Iso2700127701ControlModificacion[];
  loading: boolean;
  error: string | null;
  onRetry: () => void;
  onCreate: () => void;
  onEdit: (row: Iso2700127701ControlModificacion) => void;
  onDelete: (row: Iso2700127701ControlModificacion) => void;
};

export function Iso2700127701ControlModificacionesTable({
  rows,
  loading,
  error,
  onRetry,
  onCreate,
  onEdit,
  onDelete,
}: Props) {
  const columns: Iso2700127701TableColumn<Iso2700127701ControlModificacion>[] = [
    {
      key: "acciones",
      header: "Acciones",
      className: "iso27001-actions-column",
      render: (row) => (
        <div className="iso27001-row-actions">
          <Iso2700127701IconButton
            label="Editar modificación"
            icon={<Edit3 size={15} />}
            onClick={() => onEdit(row)}
          />
          <Iso2700127701IconButton
            label="Eliminar modificación"
            icon={<Trash2 size={15} />}
            danger
            onClick={() => onDelete(row)}
          />
        </div>
      ),
    },
    {
      key: "fecha",
      header: "Fecha",
      className: "iso27001-date-column",
      render: (row) => row.fecha,
    },
    {
      key: "modificaciones",
      header: "Modificaciones realizadas",
      className: "iso27001-extra-long-text-column",
      render: (row) => (
        <Iso2700127701ScrollableCell title={row.modificaciones_realizadas}>
          {row.modificaciones_realizadas}
        </Iso2700127701ScrollableCell>
      ),
    },
  ];

  return (
    <Iso2700127701DataTable
      title="Control documental"
      countLabel={`${rows.length} modificaciones`}
      rows={rows}
      columns={columns}
      getRowKey={(row) => row.id}
      loading={loading}
      error={error}
      emptyTitle="Sin modificaciones registradas"
      emptyDescription="Añade el primer registro de control documental de esta sección."
      createLabel="Añadir modificación"
      onCreate={onCreate}
      onRetry={onRetry}
    />
  );
}
